function initSliderPagination(sliderComponent) {
  const slider = sliderComponent.querySelector('.slider');
  const slides = slider.querySelectorAll('li.slider__slide');
  const paginationContainer = sliderComponent.querySelector('.slider-pagination');

  if (!slider || !paginationContainer) return;

  paginationContainer.innerHTML = '';
  if (slides.length <= 1) return;

  const dots = [];
  let currentIndex = 0;

  function renderDots(activeIndex) {
    paginationContainer.innerHTML = '';
    dots.length = 0;
    let total = slides.length;
    let maxVisible = 5;
    let start = Math.max(0, Math.min(activeIndex - 2, total - maxVisible));
    let end = Math.min(total, start + maxVisible);
    if (end - start < maxVisible && total >= maxVisible) start = end - maxVisible;

    for (let i = start; i < end; i++) {
      const dot = document.createElement('button');
      dot.classList.add('pagination-dot');
      
      const distance = Math.abs(i - activeIndex);
      const positionInVisible = i - start; // position in visible dots (0-4)
      
      if (distance === 0) {
        dot.classList.add('active', 'dot-largest');
      } else {
        // Static sizes depending on the active position
        if (activeIndex === start) {
          // First active: largest, medium, medium, small, tiny
          if (positionInVisible === 0) dot.classList.add('dot-largest');
          else if (positionInVisible === 1 || positionInVisible === 2) dot.classList.add('dot-medium');
          else if (positionInVisible === 3) dot.classList.add('dot-small');
          else dot.classList.add('dot-tiny');
        } else if (activeIndex === start + 1) {
          // Second active: medium, largest, medium, small, tiny
          if (positionInVisible === 1) dot.classList.add('dot-largest');
          else if (positionInVisible === 0 || positionInVisible === 2) dot.classList.add('dot-medium');
          else if (positionInVisible === 3) dot.classList.add('dot-small');
          else dot.classList.add('dot-tiny');
        } else if (activeIndex === start + 2) {
          // Third active: tiny, small, largest, small, tiny
          if (positionInVisible === 2) dot.classList.add('dot-largest');
          else if (positionInVisible === 1 || positionInVisible === 3) dot.classList.add('dot-small');
          else dot.classList.add('dot-tiny');
        } else if (activeIndex === start + 3) {
          // Fourth active: tiny, small, medium, largest, medium
          if (positionInVisible === 3) dot.classList.add('dot-largest');
          else if (positionInVisible === 2 || positionInVisible === 4) dot.classList.add('dot-medium');
          else if (positionInVisible === 1) dot.classList.add('dot-small');
          else dot.classList.add('dot-tiny');
        } else {
          // Fifth active: tiny, small, medium, medium, largest
          if (positionInVisible === 4) dot.classList.add('dot-largest');
          else if (positionInVisible === 2 || positionInVisible === 3) dot.classList.add('dot-medium');
          else if (positionInVisible === 1) dot.classList.add('dot-small');
          else dot.classList.add('dot-tiny');
        }
      }
      
      dot.addEventListener('click', () => {
        slider.scrollTo({
          left: slides[i].offsetLeft,
          behavior: 'smooth',
        });
        currentIndex = i;
        renderDots(currentIndex);
      });
      paginationContainer.appendChild(dot);
      dots.push(dot);
    }
  }

  slider.addEventListener('scroll', () => {
    let closestIndex = 0;
    let closestDistance = Infinity;
    const scrollLeft = slider.scrollLeft;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestIndex = index;
        closestDistance = distance;
      }
    });
    currentIndex = closestIndex;
    renderDots(currentIndex);
  });

  renderDots(currentIndex);
}

function observeSliderChanges(sliderComponent) {
  const slider = sliderComponent.querySelector('.slider');
  if (!slider) return;

  const observer = new MutationObserver(() => {
    setTimeout(() => {
      initSliderPagination(sliderComponent);
    }, 100); // pozwól DOM się zaktualizować
  });

  observer.observe(slider, {
    childList: true,
    subtree: false, // wystarczy same <li>
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const sliderComponent = document.querySelector('slider-component');
  if (!sliderComponent) return;

  initSliderPagination(sliderComponent);
  observeSliderChanges(sliderComponent);

  // Obsługa zmiany wariantu
  document.querySelectorAll('input.single-option-selector[name^="Colors"]').forEach(input => {
    input.addEventListener('change', () => {
      setTimeout(() => {
        initSliderPagination(sliderComponent);
      }, 300); 
    });
  });
});
